import React, { useEffect, useState } from 'react'
import { API_URL } from '../../env'
import axios from 'axios'
import { Fade, Zoom } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDesktop, faEnvelope, faPhone, faUser, faUserTag } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Admin/AdminContact.css'
import AccordionItem from '../Utils/AccordionItem'

function AdminContact({ adminRouter, adminRouterPrev, setAdminRouterPrev }) {

    const [accordionIndex, setAccordionIndex] = useState(null)
    const [contacts, setContacts] = useState([])

    useEffect(() => {

        getContact()

    }, [])

    function getContact() {

        axios.get(API_URL + 'contact').then((response) => {
            response.data.map((item) => {
                item.createdAt = new Date(item.createdAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
                if (item.type === 'Phone') {
                    item.type = 'Demande de rappel'
                } else if (item.type === 'Quote') {
                    item.type = 'Demande de devis'
                } else if (item.type === 'Email') {
                    item.type = 'Demande de contact'
                }
                return item
            })
            setContacts(response.data)
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    return (

        <div id='adminContact'>
            <Fade direction={adminRouterPrev === 'diagnostic' || adminRouterPrev === 'customer' || adminRouterPrev === 'payment' ? 'right' : 'left'} duration={500} triggerOnce={true}>
                <Accordion defaultActiveKey={accordionIndex} activeKey={accordionIndex}>
                    {contacts.map((item, index) => {
                        return (
                            <AccordionItem
                                key={item.id}
                                indexKey={index}
                                index={accordionIndex}
                                setIndex={setAccordionIndex}
                                animated={false}
                                header={
                                    <>
                                        {item.createdAt} - {item.type} - {item.name}
                                    </>
                                }
                                body={
                                    <Row>
                                        <Col>
                                            <table>
                                                <tbody>
                                                    <tr className='adminInfoText'>
                                                        <td className='adminInfoTextIcon'>
                                                            <FontAwesomeIcon icon={faEnvelope} />
                                                        </td>
                                                        <td>
                                                            {item.message}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </Col>
                                        <Col>
                                            <Zoom duration={500} delay={100}>
                                                <div className='adminCard'>
                                                    <div className='adminCardTitle'>
                                                        <FontAwesomeIcon icon={faUser} className='adminCardTitleIcon' />
                                                        Information Utilisateur :
                                                    </div>
                                                    <table>
                                                        <tbody>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faUserTag} />
                                                                </td>
                                                                <td>
                                                                    {item.name}
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faPhone} />
                                                                </td>
                                                                <td>
                                                                    {item.phone}
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                                </td>
                                                                <td>
                                                                    {item.email}
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faDesktop} />
                                                                </td>
                                                                <td>
                                                                    {item.ip}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Zoom>
                                        </Col>
                                    </Row>
                                }
                            />
                        )
                    })}
                </Accordion>
            </Fade>
        </div>

    )

}

export default AdminContact